<template>
  <button class="btn -relative" type="button" @click="copyRecipeUrlToClipboard">
    <i v-if="urlCopied" class="material-symbols-outlined fill" aria-hidden="true">exit_to_app</i>
    <i v-else class="material-symbols-outlined" aria-hidden="true">exit_to_app</i>
    {{ urlCopied ? 'Recipe Link Copied' : 'Export Recipe to App' }}

    <span
      aria-live="polite"
      role="status"
      :class="['copy-notification', { '-visible': notificationVisible }]"
      :aria-hidden="notificationVisible ? 'false' : 'true'"
    >
      Copied to Clipboard
    </span>
  </button>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'ExportUrlButton',
  components: {},
  props: {
    url: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      urlCopied: false,
      notificationVisible: false,
    }
  },
  computed: {},

  methods: {
    async copyRecipeUrlToClipboard() {
      try {
        // Clipboard API is only supported by more modern browsers
        // @see https://caniuse.com/async-clipboard
        await navigator.clipboard.writeText(this.url)
      } catch (e) {
        // fall back solution for older browsers that don't support the api
        // NOTE: Only supported in Safari for v10 and higher
        const tempInput = document.createElement('input')
        tempInput.value = this.url
        // prevent iOS from scrolling to bottom of screen for invisible input
        tempInput.readOnly = true
        const body = document.querySelector('body')

        if (body) {
          body.appendChild(tempInput)

          // additional configuration for iOS
          if (navigator.userAgent.match(/ipad|iphone/i)) {
            let range = document.createRange()
            range.selectNodeContents(tempInput)

            let selection = window.getSelection() as Selection
            selection.removeAllRanges()
            selection.addRange(range)
            tempInput.setSelectionRange(0, 999999)
          } else {
            // non-iOS
            tempInput.select()
          }

          // only used on old browsers
          document.execCommand('copy')
          body.removeChild(tempInput)
        }
      } finally {
        this.urlCopied = true
        this.notificationVisible = true
        // triggers fade styling, comment out for testing
        setTimeout(() => {
          this.notificationVisible = false
        }, 2000)
      }
    },
  },
})
</script>
